import { TableUI } from "components/design/TableUI";
import {
  ActionsColumn,
  AIColumn,
  DueDateColumn,
  InvoiceAmountColumn,
  InvoiceDateColumn,
  InvoiceNumberColumn,
  InvoiceSelectColumn,
  SentToColumn,
  SourceColumn,
  StatusColumn,
} from "components/InvoiceColumns/InvoiceColumns";
import { useMemo, useState } from "react";
import {
  getCoreRowModel,
  RowSelectionState,
  useReactTable,
  SortingState,
} from "react-table-8.10.7";
import { Invoice } from "types/Models/invoice";

export const InvoiceTable = ({
  invoicesData,
  onRowClick,
  disabledRowIds = [],
  showActionsColumn = true,
  rowSelection = {},
  setRowSelection,
  sorting: sortingProp,
  setSorting: setSortingProp,
  className,
}: {
  invoicesData?: Invoice[];
  onRowClick?: (uuid: string, status: string) => void;
  disabledRowIds?: string[];
  showActionsColumn?: boolean;
  rowSelection?: RowSelectionState;
  setRowSelection?: (
    updaterOrValue:
      | RowSelectionState
      | ((prev: RowSelectionState) => RowSelectionState)
  ) => void;
  sorting?: SortingState;
  setSorting?: (
    updaterOrValue: SortingState | ((prev: SortingState) => SortingState)
  ) => void;
  className?: string;
}) => {
  const [sortingLocal, setSortingLocal] = useState<SortingState>([
    {
      id: "INVOICE_DATE",
      desc: true,
    },
  ]);

  const sorting = sortingProp ?? sortingLocal;
  const setSorting = setSortingProp ?? setSortingLocal;

  const invoiceColumns = [
    InvoiceSelectColumn,
    InvoiceNumberColumn,
    SentToColumn,
    InvoiceAmountColumn,
    InvoiceDateColumn,
    DueDateColumn,
    StatusColumn,
    SourceColumn,
    AIColumn,
    ActionsColumn,
  ];

  const data = useMemo(() => invoicesData || [], [invoicesData]);
  const [displayCurrency, setDisplayCurrency] = useState<
    "INVOICE_CURRENCY" | "USD"
  >("INVOICE_CURRENCY");

  const table = useReactTable({
    data,
    columns: invoiceColumns,
    getCoreRowModel: getCoreRowModel(),
    defaultColumn: {
      minSize: 5,
    },
    onRowSelectionChange: setRowSelection,
    state: {
      sorting,
      rowSelection,
      columnVisibility: {
        Actions: showActionsColumn,
      },
    },
    manualSorting: true,
    enableMultiSort: false,
    enableSortingRemoval: false,
    getRowId: (row) =>
      JSON.stringify({
        uuid: row.uuid,
        invoice_amount: row.invoice_amount,
        due_balance: row.due_balance,
        amount_in_base_currency:
          row.payment_record_amount?.amount_in_base_currency ?? null,
      }),
    // @ts-ignore
    onSortingChange: setSorting,
    meta: {
      displayCurrency,
      setDisplayCurrency,
      disabledRows: disabledRowIds,
    },
    enableRowSelection: (row) => !disabledRowIds.includes(row.original.uuid),
  });

  return (
    <>
      <TableUI
        table={table}
        onRowClick={(row) =>
          onRowClick?.(row.original.uuid, row.original.status)
        }
        disabledRows={disabledRowIds}
        className={className}
      />
    </>
  );
};
